import Browser from '../../src/helpers/browser';
import { isSDKLite } from '../../src/helpers/is-sdklite';

/**
 * Check query string for a particular name and return name if it exists
 * @param {*} name
 * @returns {string}
 */
const paramHelper = (name = '') => {
  name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

/**
 * Check if we are in a web view
 * @returns {boolean}
 */
const isUIWebView = () => {
  const isMarkable =
    window.performance &&
    window.performance.timing &&
    (window.performance.mark && typeof window.performance.mark === 'function') &&
    (window.performance.measure && typeof window.performance.measure === 'function') &&
    (window.performance.getEntries && typeof window.performance.getEntries === 'function') &&
    (window.performance.getEntriesByName &&
      typeof window.performance.getEntriesByName === 'function') &&
    (window.performance.getEntriesByType &&
      typeof window.performance.getEntriesByType === 'function') &&
    (window.performance.clearMeasures && typeof window.performance.clearMeasures === 'function');

  return (Browser.isIOSWebView() && !isMarkable) || /uiwebview/i.test(Browser.getUserAgent());
};

/**
 * Get incoming traffic source string value
 * @returns {string}
 */
const getIncomingTrafficSource = () => {
  const isHybrid = paramHelper('isHybrid') !== '';
  const isCrossApp = paramHelper('isCrossApp') !== '';
  let incoming_traffic_source = 'web';

  if (isHybrid) {
    if (isSDKLite()) {
      incoming_traffic_source = new RegExp('w*( VCO_SDK/7.)w*').test(window.navigator.userAgent)
        ? 'sdklite-enhanced'
        : 'sdklite';
    } else {
      incoming_traffic_source = 'hybridplugin';
    }
  } else if (isUIWebView()) {
    incoming_traffic_source = 'hybrid-uiwebview';
  } else if (Browser.isAndroidWebview() || Browser.isIOSWebView()) {
    incoming_traffic_source = 'hybrid';
  } else if (isCrossApp) {
    incoming_traffic_source = 'sdklite-cross-app';
  }

  return incoming_traffic_source;
};

export default getIncomingTrafficSource;
